const updateFavicon = function (image) {
  const favicon = document.getElementById("favicon");

  const mimeType = getMimeType(image);

  const currentHref = favicon.href;
  const newHref = `data:image/${mimeType};base64,${image}`;

  if (currentHref !== newHref) {
    favicon.href = newHref;
  }
};

const getMimeType = function (image) {
  return image.startsWith("iVBORw0KG")
    ? "png"
    : image.startsWith("/9j/")
    ? "jpeg"
    : image.startsWith("AAABAAEA")
    ? "x-icon"
    : "png";
};

export { updateFavicon };
